import * as React from "react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * Shared file `<Input>` (CHP-807). The `file:`-prefixed className styling the
 * native file-picker button was duplicated verbatim across AddResourceDrawer
 * and AssetAdminPanel; this primitive owns it so the two stay in sync and it
 * follows a token re-skin. The disabled affordance is inherited from the base
 * Input classes, so callers only pass behaviour (onChange/accept/disabled).
 */
export const FileInput = React.forwardRef<
  HTMLInputElement,
  Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">
>(({ className, ...props }, ref) => (
  <Input
    ref={ref}
    type="file"
    className={cn(
      "h-auto cursor-pointer py-1.5 text-sm text-muted-foreground file:mr-3 file:cursor-pointer file:rounded-md file:border-0 file:bg-secondary file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-secondary-foreground hover:file:bg-secondary/80",
      className,
    )}
    {...props}
  />
));
FileInput.displayName = "FileInput";
